import { getSlateEditorValue } from '@doltech/utils/lib/editor';
import { BLOG_SECTION_PREFIX } from '../../admin-blog-management/blog-management-constant';

export const convertTocFromEditorToc = (editorToc: any, hiddenToc: string[] = []) => {
  return getSlateEditorValue(editorToc)
    ?.flatMap((eachContent, contentIndex) => {
      const { id, h3Child, ...restContent } = eachContent;

      return [
        {
          ...restContent,
          id: id || `${BLOG_SECTION_PREFIX}${contentIndex + 1}`,
        },
        ...((h3Child || []).map((eachH3Child, h3ChildIndex) => ({
          ...eachH3Child,
          id: eachH3Child.id || `${BLOG_SECTION_PREFIX}${contentIndex + 1}-${h3ChildIndex + 1}`,
        })))
      ];
    })
    .filter((eachContent) => !hiddenToc?.includes(eachContent.id))
    .map((eachContent, contentIndex) => ({
      headingIndex: contentIndex,
      id: eachContent.id,
      type: eachContent.type,
      text: eachContent.children?.[0]?.text,
      orderIndex: eachContent.orderIndex,
      headingLevel: eachContent.headingLevel,
    }));
};
